import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from '../../services/language/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
  currentLang: string;

  constructor(
    private languageService: LanguageService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {
    this.currentLang = this.languageService.getCurrentLanguage();
  }

  ngOnInit(): void {
    this.currentLang = this.languageService.getCurrentLanguage();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang;
      this.cdRef.detectChanges();
    });
  }

  changeLang(lang: string): void {
    this.languageService.setLanguage(lang);
    this.cdRef.detectChanges(); 
  }
}
